import React from 'react';
import NavItem from './NavItem';

function NavBar() {
  return <NavItem />;
}

export default NavBar;
